import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk } from '../store';
import * as IdentyumServiceApi from '../api/kentIdentyumServiceApi';
import { Psd2LimitsConfig } from 'kent-identyum-service-api';
import { ErrorType } from '../lib/constants/errorTypes';

interface IProcessState {
    error: ErrorType | undefined;
    isLoading: boolean;
    isSaving: boolean;
    saveSuccess: boolean;
    config: Psd2LimitsConfig | null;
}

const initialState: IProcessState = {
    error: undefined,
    isLoading: true,
    isSaving: false,
    saveSuccess: false,
    config: null,
};

const psd2ControllerSlice = createSlice({
    name: 'psd2Controller',
    initialState,
    reducers: {
        setLoading(state: IProcessState, action: PayloadAction<boolean>) {
            state.isLoading = action.payload;
        },
        setSaving(state: IProcessState, action: PayloadAction<boolean>) {
            state.isSaving = action.payload;
        },
        setConfig(state: IProcessState, action: PayloadAction<Psd2LimitsConfig>) {
            state.config = action.payload;
            state.isLoading = false;
            state.isSaving = false;
        },
        setSaveSuccess(state: IProcessState) {
            state.saveSuccess = true;
            state.isSaving = false;
        },
        clearSuccess(state: IProcessState) {
            state.saveSuccess = false;
        },
        setError(state: IProcessState, action: PayloadAction<ErrorType>) {
            state.isLoading = false;
            state.isSaving = false;
            state.error = action.payload;
        },
        clearError(state: IProcessState) {
            state.error = undefined;
        },
    },
});

export const getPsd2LimitsConfig =
    (): AppThunk =>
    async (dispatch): Promise<void> => {
        try {
            const config = await IdentyumServiceApi.getPsd2LimitsConfig();
            dispatch(psd2ControllerSlice.actions.setConfig(config));
        } catch (error: any) {
            dispatch(psd2ControllerSlice.actions.setError(ErrorType[error?.response?.data?.type] ?? ErrorType.GENERIC));
        }
    };

export const putPsd2LimitsConfig =
    (config: Psd2LimitsConfig): AppThunk =>
    async (dispatch): Promise<void> => {
        dispatch(psd2ControllerSlice.actions.setSaving(true));
        try {
            const savedConfig = await IdentyumServiceApi.putPsd2LimitsConfig(config);
            dispatch(psd2ControllerSlice.actions.setConfig(savedConfig));
            dispatch(psd2ControllerSlice.actions.setSaveSuccess());
        } catch (error: any) {
            dispatch(psd2ControllerSlice.actions.setError(ErrorType[error?.response?.data?.type] ?? ErrorType.GENERIC));
        }
    };

export const { clearError, clearSuccess, setLoading } = psd2ControllerSlice.actions;

export const { reducer } = psd2ControllerSlice;

export default psd2ControllerSlice;
